import client from 'api/client';
import { AxiosResponse, AxiosRequestConfig } from 'axios';

// Define the payload structure
interface ChatWithAiPayload {
    message: string;
    history: { role: string; content: string }[]; // Adjust based on the actual structure
}

// Define the response structure
interface ChatWithAiResponse {
    response: string;
}

// Updated function with improved typing
export function post(
    payload: ChatWithAiPayload,
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse<ChatWithAiResponse>> {
    return client.post<ChatWithAiResponse>('/chatbot', payload, customConfig);
}
